import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponentV2 } from '../../../../../shared/components/icon-component/icon.component';
import { UnpaidPaymentsPaymentStatusModalData } from '../../unpaid-payments-modal.types';

@Component({
  selector: 'app-unpaid-payments-payment-status-modal',
  standalone: true,
  imports: [CommonModule, IconComponentV2],
  templateUrl: './unpaid-payments-payment-status-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @keyframes success-badge-pop-in {
        0% {
          transform: scale(0.2);
          opacity: 0;
        }
        65% {
          transform: scale(1.12);
          opacity: 1;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }

      @keyframes success-badge-gif {
        0%,
        100% {
          transform: scale(1) rotate(0deg);
        }
        35% {
          transform: scale(1.08) rotate(-3deg);
        }
        70% {
          transform: scale(1.05) rotate(3deg);
        }
      }

      .success-badge-pop-in {
        animation: success-badge-pop-in 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
      }

      .success-badge-gif {
        animation: success-badge-gif 1.4s ease-in-out 0.55s infinite;
      }
    `,
  ],
})
export class UnpaidPaymentsPaymentStatusModalComponent {
  private readonly dialogData = inject<UnpaidPaymentsPaymentStatusModalData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<UnpaidPaymentsPaymentStatusModalComponent, void>);

  readonly title = this.dialogData.title ?? 'Payment Status';
  readonly confirmLabel = this.dialogData.confirmLabel ?? 'Done';
  readonly amount = this.dialogData.amount ?? null;
  readonly statusMessage = this.dialogData.statusMessage ?? 'Paid Successfully';
  readonly subtitle = this.dialogData.subtitle;

  close(): void {
    this.dialogRef.close();
  }
}
